<div class="creation-lead-car" [formGroup]="form">
  <div class="header">
    <h4>Car {{ index + 1 }}</h4>
  </div>
  <app-spinner [loading]="false">
    <div class="body">
      <div class="fields">
        <mat-form-field>
          <mat-select
            placeholder="Car Year"
            (selectionChange)="onYearChanged($event.value)"
            [formControlName]="fields.year.name"
          >
            <mat-option
              *ngFor="let year of carYearOptions"
              [value]="year"
            >
              {{ year }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-select
            placeholder="Car Model"
            [disabled]="!(carModelOptions$ | async)?.length"
            (selectionChange)="onModelChanged($event.value)"
            [formControlName]="fields.model.name"
          >
            <mat-option
              *ngFor="let model of carModelOptions$ | async"
              [value]="model"
            >
              {{ model }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="fields">

        <mat-form-field>
          <mat-select
            placeholder="Car Make"
            (selectionChange)="onMakeChanged($event.value)"
            [formControlName]="fields.make.name"
          >
            <mat-option
              *ngFor="let make of carMakeOptions$ | async"
              [value]="make"
            >
              {{ make }}
            </mat-option>
          </mat-select>
        </mat-form-field>      

        <mat-form-field>
          <mat-select
            placeholder="Car Type"
            [disabled]="!(carTypeOptions$ | async)?.length"
            (selectionChange)="onTypeChanged($event.value)"
            [formControlName]="fields.type.name"
          >
            <mat-option
              *ngFor="let type of carTypeOptions$ | async"
              [value]="type"
            >
              {{ type }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="action">
        <button mat-icon-button (click)="OnRemove.emit(index)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  </app-spinner>
</div>
